import { products, type Product } from "../data/products";
import ProductCard from "../components/ProductCard";
import SEOMeta from "components/SEOMeta";
import { brandConfig } from "config/brandConfig";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import CategorySEO from "components/CategorySEO";

export default function Products() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil", href: "/" }, { label: "Produits" }]);
  }, [setItems]);
  return (
    <>
      <SEOMeta
        title="Produits"
        description={`Découvrez la gamme complète des armoires à fusils sécurisées ${brandConfig.brandName} pour la protection optimale de vos armes.`}
      />
      <CategorySEO products={products} />
      <h1>Produits</h1>
      <div className="grid" style={{ marginTop: 12 }}>
        {products.map((product: Product) => (
          <ProductCard key={product.sku} productSpecific={product} />
        ))}
      </div>
    </>
  );
}
